import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchProducts = (params = {}) => api.get("/products", { params }).then(r => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then(r => r.data);
export const fetchRelated = (slug) => api.get(`/products/${slug}/related`).then(r => r.data);
export const fetchReviews = (productId) => api.get(`/reviews/${productId}`).then(r => r.data);
export const fetchAllReviews = () => api.get(`/reviews`).then(r => r.data);
export const fetchCollectionsMeta = () => api.get(`/collections/meta`).then(r => r.data);
export const subscribeNewsletter = (email) => api.post(`/newsletter`, { email }).then(r => r.data);
export const submitContact = (data) => api.post(`/contact`, data).then(r => r.data);
export const validateCoupon = (code) => api.post(`/coupon/validate`, {}, { params: { code } }).then(r => r.data);
export const placeOrder = (data) => api.post(`/orders`, data).then(r => r.data);
export const trackOrder = (num, email) => api.get(`/orders/${num}`, { params: email ? { email } : {}, withCredentials: true }).then(r => r.data);
export const addReview = (data) => api.post(`/reviews`, data).then(r => r.data);

export const formatINR = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

// For uploaded images returned as `/api/files/...`, prefix with backend URL so <img> resolves correctly.
export const imageUrl = (u) => {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};
